import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import Popup from "@my-dld/components/Popup/Popup";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { StringUtil } from "@eres/core";
import { AppConstants } from "../../../configApp";
import { SSOApi } from "@eres/ssoapi";
import { exToMessage } from "@eres/ssoapi/api";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { ProfileUpdateRequest, ProfileUpdateResponse, SSOResponse } from "@eres/ssoapi/entities";

interface Props {
	mobile?: string;
	email?: string;
	onDismiss?: () => void;
	onUserVerified?: () => void;
	maxOTPLength?: number;
	resend_label?: string;
	resend_label_link?: string;
	api?: ( request: ProfileUpdateRequest ) => Promise<SSOResponse<ProfileUpdateResponse>>;
	eventCategory?: string;
	noResend?: boolean;
}

interface State {
	mobile?: string;
	email?: string;
	error?: string;
	isLoading?: boolean;
	isResending: boolean;
	msg: { email?: any; mobile?: any };
	doneVerification: string[];
}

function buildMessage( message: string, xClass: string = "" ) {
	return <div className={ "text-center mt-2" }>
        <span className={ xClass + " p-2" }>
        { message }</span>
	</div>;
}

class SSOVerifyPopup extends Component<Props, State> {
	static defaultProps: Partial<Props> = {
		maxOTPLength: 8,
	};

	constructor( props: Props ) {
		super( props );
		this.state = {
			doneVerification: [],
			isResending: false,
			email: "",
			mobile: "",
			msg: {}
		};
	}

	isValid = () => {
		let isValid = true;
		if ( this.props.mobile )
			isValid = isValid && !StringUtil.isEmptyStringOrNull( this.state.mobile ) && this.state.mobile !== undefined && this.state.mobile?.length > 3;
		if ( this.props.email )
			isValid = isValid && !StringUtil.isEmptyStringOrNull( this.state.email ) && this.state.email !== undefined && this.state.email?.length > 3;
		return isValid;
	};

	render() {
		let { email = "", mobile = "", error, isLoading, isResending, doneVerification } = this.state;
		const { noResend } = this.props;
		const isValid = this.isValid();
		return (
			<Popup
				id={ "token-verify" } showCloseButton={ true } onDismiss={ this.props.onDismiss }
				clickOutsideToDismiss={ false }>
				<div className="text-center">
					<img
						alt={ "otp" }
						className="mt-3 mb-3"
						src={ `${ AppConstants.rootUrl }assets/img/password.png` }/>
				</div>
				<div className="text-center">
					<strong>{ Strings.verification }</strong>
				</div>
				{ this.props.mobile &&
					<React.Fragment>
						<p className="mt-2 text-center">{ Strings.please_enter_the_otp_on } &nbsp; { this.props.mobile }</p>
						<OTPInput
							disabled={ doneVerification.indexOf( "mobile" ) !== -1 }
							msg={ this.state.msg.mobile }
							maxLength={ this.props.maxOTPLength } value={ mobile } isResending={ isResending }
							onValue={ value => {
								this.setState( {
									mobile: value
								} );
							} } onResend={ noResend === true ? undefined : () => {
							this.onResend( "mobile" );
						} }/>
					</React.Fragment>
				}
				{ this.props.email &&
					<React.Fragment>
						<p className="mt-2 text-center">{ Strings.please_enter_the_otp_on } &nbsp; { this.props.email }</p>
						<OTPInput
							disabled={ doneVerification.indexOf( "email" ) !== -1 }
							maxLength={ this.props.maxOTPLength }
							msg={ this.state.msg.email }
							value={ email } isResending={ isResending }
							onValue={ value => {
								this.setState( {
									email: value
								} );
							} } onResend={ noResend === true ? undefined : () => {
							this.onResend( "email" );
						} }/>
					</React.Fragment>
				}
				{ error && <div className={ "invalid-feedback invalid-feedback-x" }>
					{ error }
				</div> }
				<div className="form-group mb-4 mb-0 text-center">
					<button
						disabled={ !isValid }
						className="btn btn_1 otp-btn"
						type="button" onClick={ this.onVerify }>
						{ ( isLoading ) ? <div className="relative spinner-border " role="status">
							<span className="sr-only">Loading...</span>
						</div> : Strings.verify }
					</button>
				</div>
			</Popup>
		);
	}

	setError = ( field: "mobile" | "email", error: string ) => {
		this.setState( {
			msg: {
				...this.state.msg,
				[ field ]: buildMessage( error, "invalid-feedback invalid-feedback-x" )
			}
		} );
	};
	onResend = ( v: "mobile" | "email" ) => {
		this.setState( { isResending: true, error: undefined } );
		SSOApi.profile.resendOTPForUpdate( { mobile: v === "mobile", email: v === "email" } )
		.then( () => {
			this.setState( { isResending: false } );
			const fs = new Set( this.state.doneVerification );
			fs.delete( v );
			const update: Partial<State> = {
				isResending: false,
				doneVerification: Array.from( fs ),
			};
			update.msg = {
				...this.state.msg,
				[ v ]: buildMessage( Strings.txt_success )
			};
			this.setState( update as State, () => {
				setTimeout( () => {
					this.setState( {
						msg: {
							...this.state.msg,
							[ v ]: undefined,
						}
					} );
				}, 5000 );
			} );
		} ).catch( e => {
			this.setState( { isResending: false } );
			return exToMessage( e ).then( msg => {
				throw  msg.error;
			} ).catch( ex => {
				this.setState( {
					error: ex.toString(),
				} );
			} );
		} );
	};
	onVerify = () => {
		if ( this.state.isLoading ) return;
		const { eventCategory = "SSOProfile", api = SSOApi.profile.verifyOTPForUpdate } = this.props;
		this.setState( { error: undefined, msg: {} } );
		const rq: { email?: string, mobile?: string } = {};
		if ( this.props.mobile ) {
			if ( StringUtil.isEmptyStringOrNull( this.state.mobile ) || this.state.mobile!.length < 3 ) {
				this.setState( { error: Strings.invalid_otp } );
				return;
			}
			rq.mobile = this.state.mobile;
		}
		if ( this.props.email ) {
			if ( StringUtil.isEmptyStringOrNull( this.state.email ) || this.state.email!.length < 3 ) {
				this.setState( { error: Strings.invalid_otp } );
				return;
			}
			rq.email = this.state.email;
		}
		this.setState( { isLoading: true } );
		trackEventWithData( eventCategory, "UpdateVerify" );
		const verifiedItems: string[] = [];
		api( rq ).then( x => {
			let isValid = true;
			const sp = x.data;
			this.setState( { isLoading: false } );
			if ( this.props.email && sp.email ) {
				if ( sp.email.status !== "VERIFIED" ) {
					isValid = false;
					this.setError( "email", Strings.invalid_otp );
				} else {
					verifiedItems.push( "email" );
				}

			}
			if ( this.props.mobile && sp.mobileNumber ) {
				if ( sp.mobileNumber.status !== "VERIFIED" ) {
					isValid = false;
					this.setError( "mobile", Strings.invalid_otp );
				} else {
					verifiedItems.push( "mobile" );
				}
			}
			if ( isValid ) {
				trackEventWithData( eventCategory, "Updated" );
				if ( this.props.onUserVerified ) this.props.onUserVerified();
			}
			this.setState( {
				doneVerification: verifiedItems,
			} );
			if ( isValid ) {
				JQModal( "token-verify" ).hide();
			}
		} ).catch( e => {
			this.setState( { isLoading: false } );
			return exToMessage( e ).then( msg => {
				throw  msg.error;
			} ).catch( ex => {
				trackEventWithData( eventCategory, "UpdateVerifyFailed" );
				this.setState( {
					error: ex.toString(),
				} );
			} );
		} );
	};

	componentDidMount(): void {
		JQModal( "token-verify" ).show();
	}
}

function OTPInput( props: {
	value: string, onValue: ( value: string ) => void, isResending: boolean, onResend?: () => void;
	maxLength?: number, msg: any, disabled: boolean,
} ) {
	const { value, isResending, onResend, onValue, maxLength, msg, disabled } = props;
	return <div className="form-group field-style mb-4 text-center">
		<input
			className="form-control text-center otp-field" placeholder="******"
			value={ value }
			disabled={ disabled }
			onChange={ ( e ) => {
				let value = e.target.value;
				let mx = e.target.maxLength;
				if ( mx != null && mx !== -1 ) {
					if ( value && value.length > mx ) {
						value = value.slice( 0, mx );
					}
				}
				onValue( value );
			} }
			maxLength={ maxLength }
			type="password"/>
		{ msg }
		{ onResend != null &&
			<div className="btn-resend">
				{ !isResending && !disabled && <>
					<button onClick={ onResend } className={ "" }>
						<i className={ " " + ( isResending ? "animated-refresh" : "" ) } aria-hidden="true"/>
						{ Strings.resend }
					</button>
				</> }
				{ isResending && <>
					<div className="spinner-border" role="status">
						<span className="sr-only">Loading...</span>
					</div>
				</> }

			</div>
		}
	</div>;
}

export default SSOVerifyPopup;
